export function getCustomContent(requestPath) {
  return {
    type: 'GET_CUSTOM_CONTENT',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: requestPath,
            mock: false,
          },
        },
        commit: {
          type: `GET_CUSTOM_CONTENT_COMMIT`,
        },
        rollback: {
          type: 'GET_CUSTOM_CONTENT_ROLLBACK',
        },
      },
    },
  }
}
